import { FlyoutDrsFileInfoGeneric } from "components/FlyoutDrsFileInfo/FlyoutDrsFileInfoGeneric";
import { RightFlyoutContent } from "../store/DataTableProvider.types";
import { FlyoutTableNotes } from "components/FlyoutTableNotes/FlyoutTableNotes";

interface DataTableFlyoutRightProps {
  content: RightFlyoutContent;
  fileId?: string;
  onClose: () => void;
  tableId: string;
}

/** Component that renders a right-side flyout for a data table */
export const DataTableFlyoutRight = ({
  content,
  fileId,
  onClose,
  tableId,
}: DataTableFlyoutRightProps) => {
  if (content === "fileInfo" && fileId !== undefined) {
    return (
      <FlyoutDrsFileInfoGeneric drsFile={{ id: fileId }} onClose={onClose} />
    );
  }
  if (content === "tableNotes") {
    return <FlyoutTableNotes tableId={tableId} onClose={onClose} />;
  }
  return null;
};
